export enum WorkStream {
  DE = 'data-engineering',
  AI = 'agentic-ai',
  ML = 'machine-learning',
  DV = 'data-visualization'
}
